import styled from '@emotion/styled';
import { TextField } from '@mui/material';
import { colors } from 'theme/colors';

export const StyledTextField = styled(TextField)({
  fieldset: {
    borderRadius: 4,
  },
  input: {
    fontSize: 14,
    backgroundColor: `${colors.white}`,
    boxSizing: 'border-box',
    padding: '8px 12px',
  },
  textarea: {
    fontSize: 14,
    padding: '10px',
  },
  'input::placeholder, textarea::placeholder': {
    fontSize: 16,
    fontWeight: 400,
    color: `${colors.gray300}`,
    fontFamily: 'NotoSansRegular, sans-serif',
    opacity: 1,
  },
  '& .MuiInputBase-adornedEnd': {
    padding: '0',
    alignItems: 'stretch',
  },
  '& .MuiOutlinedInput-root': {
    marginBottom: 3,
    backgroundColor: `${colors.white}`,
    height: 40,

    '& fieldset': {
      borderColor: colors.gray300,
    },
    '& ~ p': {
      marginLeft: '0px',
    },
  },
  '& .MuiOutlinedInput-input': {
    height: 40,
  },
});
